import { matchPath, useLocation, useNavigate } from 'react-router-dom'

import { StyledTab, StyledTabs } from 'common/components/StyledTabs'
import {
  IQRANavUtilsConsumerComponentInitProps,
  QRAViewType
} from 'common/utils/navigation/qraNavUtils'

import tailwind from 'styles/themeTokens'

/**
 * Graph / Table tab navigation for QRA views
 * Tab navigation requires supporting routes to be defined in router
 * which is set up for QRA current state, saved state, compare states
 *
 * @param qraViewBasePath - URL path the tab selection generated url to be based on
 * @returns toggle component
 */
const GraphsAndTableTab = ({
  qraViewBasePath
}: IQRANavUtilsConsumerComponentInitProps) => {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  const pathMatch = matchPath(`${qraViewBasePath}/:tabView`, pathname)

  let selectedView = QRAViewType.Graph

  if (pathMatch != null && pathMatch.params.tabView === QRAViewType.Table) {
    selectedView = QRAViewType.Table
  }

  const handleTabSelect = (
    _event: React.ChangeEvent<object>,
    idx: number
  ): void => {
    const tabView = idx === 0 ? QRAViewType.Graph : QRAViewType.Table

    navigate(`${qraViewBasePath}/${tabView}${search}`)
  }

  return (
    <StyledTabs
      value={selectedView === QRAViewType.Graph ? 0 : 1}
      onChange={handleTabSelect}
      style={{ minHeight: '40px', height: '40px' }}
    >
      <StyledTab
        label='GRAPHS'
        sx={{
          fontWeight: 500,
          fontSize: 14,
          minHeight: '40px',
          minWidth: 0,
          height: '40px',
          lineHeight: 1,
          letterSpacing: '0.01em',
          px: '12px',
          color: tailwind.theme.colors.gray[500]
        }}
      />
      <StyledTab
        label='DATA TABLE'
        sx={{
          fontWeight: 500,
          fontSize: 14,
          minHeight: '40px',
          minWidth: 0,
          height: '40px',
          lineHeight: 1,
          letterSpacing: '0.01em',
          px: '12px',
          color: tailwind.theme.colors.gray[500]
        }}
      />
    </StyledTabs>
  )
}

export default GraphsAndTableTab
